export const sendYandexAction = (action:string, key:string) => {
    return window.ym(89579130, action, key);
};
